import { Grid, Typography } from "@mui/material";
import NewVersion from "../../assets/png/new_version_uprade.png";
import { useTranslation } from "react-i18next";

export const NewVersionModal = ({ appCurrentVersion, onCancelUpdateModal }) => {
  const { t } = useTranslation();
  return (
    <Grid
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100vh"}
      width={"100vw"}
    >
      <Grid
        backgroundColor={"white"}
        height={"40vh"}
        width={"80vw"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        borderRadius={3}
        flexDirection={"column"}
      >
        <img src={NewVersion} height={100} width={100} />
        <Typography
          style={{
            fontFamily: "Segoe UI",
            fontSize: 14,
            fontWeight: 600,
            textAlign: "center",
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          A new version is available. Please update via the Play Store (Android)
          or App Store (iOS).
        </Typography>
        <Typography>{appCurrentVersion}</Typography>
        <Grid
          display={"flex"}
          width={"100%"}
          justifyContent={"flex-end"}
          alignItems={"flex-end"}
        >
          <Grid>
            <Typography
              onClick={() => onCancelUpdateModal()}
              textAlign={"end"}
              color={"#1d5ab9"}
              fontWeight={"bold"}
              marginTop={"20px"}
              marginRight={"20px"}
            >
              {t("commonLabels.text02")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
